export const FONT_FAMILIES = {
  BOLD: 'bold',
  REGULAR: 'regular',
};

export const THEMES = {
  CRM: 'crm',
  WHITE: 'white',
  GRAY: 'gray',
  GREEN: 'green',
  YELLOW: 'yellow',
  RED: 'red',
  LIGHT_GREEN: 'light-green',
  LIGHT_YELLOW: 'light-yellow',
  LIGHT_RED: 'light-red',
  TRANSPARENT: 'transparent',
};

export const SIZES = {
  TINY: 'tiny',
  SMALL: 'small',
  MEDIUM: 'medium',
  'EXTRA-MEDIUM': 'extra-medium',
  LARGE: 'large',
};

export const HEIGHTS = {
  FLUID: 'fluid',
  INHERIT: 'inherit',
};

export const TITLE_POSITION = {
  TOP_CENTER: 'top center',
  TOP_LEFT: 'top left',
  RIGHT_CENTER: 'right center',
};
